import { AxiosResponse } from "axios";
import { FetchConsentResponse } from "../../models/consent-models";
import {
    RegisterContactRequest,
    RegistrationConsentModel,
    RegistrationRequest,
    RegistrationPlayerModel,
    VerifyContactRequest,
    ClosePlayerAccountRequest,
    NewPasswordRequest,
} from "../../models/registration-models";
import { playDigitalClientV1 } from "../../play-digital-client-v1";

export async function fetchConsents(): Promise<FetchConsentResponse[]> {
    const response = await playDigitalClientV1.get<FetchConsentResponse[]>("/players/consents?language=cs_CZ");
    return response.data;
}

export async function callRegisterUser(
    phoneNumber: string,
    password: string,
    consents: RegistrationConsentModel[],
): Promise<RegistrationPlayerModel> {
    const response = await playDigitalClientV1.post<RegistrationPlayerModel, AxiosResponse<RegistrationPlayerModel>, RegistrationRequest>(
        "/players",
        {
            profile: {
                registrationLevel: 2,
            },
            password: password,
            personalInfo: {
                phones: {
                    MOBILE: {
                        type: "MOBILE",
                        number: phoneNumber,
                    },
                },
            },
            consents: consents,
        },
    );
    return response.data;
}

export async function callPhoneSendVerification(userName: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, RegisterContactRequest>("/verifications/request-contact-verification", {
        contactType: "PHONE",
        username: userName,
    });
}

export async function callVerifyPhone(userName: string, verificationCode: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, VerifyContactRequest>(`/verifications/verify-contact`, {
        username: userName,
        contactType: "PHONE",
        token: verificationCode,
    });
}

export async function callEmailSendVerification(userName: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, RegisterContactRequest>("/verifications/request-contact-verification", {
        contactType: "EMAIL",
        username: userName,
    });
}

export async function callVerifyEmail(userName: string, verificationCode: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, VerifyContactRequest>(`/verifications/verify-contact`, {
        username: userName,
        contactType: "EMAIL",
        token: verificationCode,
    });
}

export async function callClosePlayerAccount(): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, ClosePlayerAccountRequest>("/players/self/close", {
        removeData: false,
        reason: "T&C_Removal",
    });
}

export async function callNewPassword(password: string, token: string): Promise<void> {
    await playDigitalClientV1.put<void, AxiosResponse<void>, NewPasswordRequest>(
        "/players/self/newpassword",
        {
            newPassword: password,
        },
        {
            headers: {
                Authorization: `Oauth ${token}`,
            },
        },
    );
}
